export default "__VITE_ASSET__f2483547__"